module.exports = __webpack_public_path__ + "static/img/b3_footer.fb1cc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b3_footer.png
// module id = RIPs
// module chunks = 1